import React, { Component } from 'react';
import Footer from '../../parts/Footer';
import { Button } from 'react-bootstrap';
import Kotak from '../../assets/images/template persegi.png';

class CheckoutPage extends Component{
    render() {
        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb ml-2 bg-transparent">
                        <li class="breadcrumb-item"><a class="text-dark" href="#">Merchandise</a></li>
                        <li class="breadcrumb-item"><a class="text-dark" href="#">Baju</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Contoh Baju</li>
                    </ol>
                </nav>

                <h2>Checkout</h2>
                <div class="container row mx-auto my-5">
                    <div class="col col-md col-12 row row-cols-1 border pt-3 mx-1">
                        <div class="col row row-cols-2">
                            <div class="col-8"><h6>Total item</h6></div>
                            <div class="col-4 text-right">2 item</div>
                        </div>
                        <div class="col row row-cols-2">
                            <div class="col-8"><h6>Total price</h6></div>
                            <div class="col-4 text-right">Rp150.000</div>
                        </div>
                        <div class="col row row-cols-2 mb-0 pb-0">
                            <div class="col-8"><h6>Total Pay (with unique code)</h6></div>
                            <div class="col-4 text-right"><span class="">Rp150.</span><span class="">150</span></div>
                        </div>
                        <div class="col"><hr class="my-3 my-md-0"/></div>
                        <div class="col">
                            <ul class="list-unstyled">
                                <li class="media">
                                    <img src={Kotak} class="mr-3" alt="..." width="60px"/>
                                    <div class="media-body">
                                    <p class="mt-0 mb-1">List-based media object</p>
                                    2
                                    </div>
                                </li>
                                <li class="media my-4">
                                    <img src={Kotak} class="mr-3" alt="..." width="60px"/>
                                    <div class="media-body">
                                    <p class="mt-0 mb-1">List-based media object</p>
                                    3
                                    </div>
                                </li>
                                <li class="media">
                                    <img src={Kotak} class="mr-3" alt="..." width="60px"/>
                                    <div class="media-body">
                                    <p class="mt-0 mb-1">List-based media object</p>
                                    4
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col col-md col-12 border mx-1 mt-5 mt-md-0">
                        <h4 class="my-3">Fill Your Information</h4>
                        <form>
                            <div class="form-group">
                                <input type="text" class="form-control" id="formGroupExampleInput" placeholder="Nama"/>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="formGroupExampleInput2" placeholder="Email"/>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="formGroupExampleInput" placeholder="Provinsi"/>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="formGroupExampleInput2" placeholder="Kabupaten/Kota"/>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="formGroupExampleInput2" placeholder="Kode Pos"/>
                            </div>
                            <div class="form-group">
                                <textarea class="form-control" id="exampleFormControlTextarea1" placeholder="Alamat Lengkap" rows="3"></textarea>
                            </div>
                        </form>
                        <Button className="shadow btn btn-primary button d-block mx-auto my-5">Confirm</Button>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}

export default CheckoutPage;